import { handleActions } from 'redux-actions';
import { initialStateList, GridFilters } from './GridFiltersReducer';

const initialState = {
  allPaymentOrdersList: { ...initialStateList },
  allPaymentOrdersBatchesList: { ...initialStateList }
};

export const PaymentOrders = handleActions(
  {
    ...GridFilters
  },
  initialState
);

const getPaymentOrders = (state) => state.PaymentOrders;

export const getPaymentOrdersList = (state, list) => {
  const paymentOrders = getPaymentOrders(state);
  return paymentOrders[list];
};

export const getOrdersBatchesList = (state) => {
  const paymentOrders = getPaymentOrders(state);
  return paymentOrders.allPaymentOrdersBatchesList;
};

export const getOrdersList = (state) => {
  const paymentOrders = getPaymentOrders(state);
  return paymentOrders.allPaymentOrdersList;
};
